module.exports = __webpack_public_path__ + "static/media/anz.5fae6683.png";